import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import {
    EquipmentUseExtendedListResponse,
    EquipmentUseQueryParams
} from '@frontend/equipment/types';

export class EquipmentUseExtendedClient extends APIClient {
    public static readonly endpoint = '/equipment-api/ext/v1';

    public static async fetchCompletedEquipmentUsesExtended(queryParams?: ApiQueryParams<EquipmentUseQueryParams>): Promise<EquipmentUseExtendedListResponse> {
        return await this.apiPaginated<EquipmentUseExtendedListResponse, EquipmentUseQueryParams>(`${this.endpoint}/completed-uses`, queryParams);
    }
}
